export function yesNoForBoolFormatter(x: boolean): string {
    switch (x) {
        case true:
            return 'Yes';
        case false:
            return 'No';
        default:
            return '';
    }
}
